import React from 'react';
import { motion } from 'motion/react';

import { useGetParams } from '../../hooks/useGetParams';
import styles from './AdvtFullSize.module.css';

import logo from '../../assets/images/logo.png';
import delo from '../../assets/images/delo.png';
import ncsp from '../../assets/images/ncsp.png';

import advtBg from '../../assets/video/advtBg4.webm';
import advtBgPoster from '../../assets/images/bgPoster.png';

const AdvtFullSize = React.memo(() => {
  const { paddingQR, sizeQR, titleFontSize, qrCode1, qrCode2, title } =
    useGetParams();

  const letters = title?.replaceAll(' ', '\u00A0')?.split('')?.reverse();
  const initLetter = letters ? Math.round(letters.length / 2) : 1;

  const initDelay = 0.4;

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="logo" className={styles.logo} />
      <img src={delo} alt="delo" className={styles.delo} />
      <img src={ncsp} alt="ncsp" className={styles.ncsp} />

      <div
        dir="rtl"
        className={styles.firstLine}
        style={{ fontSize: `${titleFontSize}rem` }}
      >
        {letters &&
          letters.map((l, idx, arr) => {
            let initialIdx = initLetter;
            let oneLetterWidth = 4;
            let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

            return (
              <motion.div
                style={{ position: 'relative', zIndex: idx * -1 }}
                key={l + idx}
                initial={{
                  scale: 0,
                  x: initialX,
                }}
                animate={{
                  scale: 1,
                  x: 0,
                }}
                transition={{
                  duration: 0.2,
                  delay: idx * 0.03 + initDelay,
                }}
              >
                {l}
              </motion.div>
            );
          })}
      </div>

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: initDelay + 1,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: initDelay + 1 + 0.56,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode1" />
          </motion.div>
        )}
      </div>

      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={advtBgPoster}
      >
        <source src={advtBg} type="video/webm" />
      </video>
    </div>
  );
});

export default AdvtFullSize;
